import { useTranslation } from "react-i18next";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import FunctionalButton from "components/layout/FunctionalButton";

interface Record360AppendStopDialogProps {
    visible: boolean;
    onConfirm: () => void;
    onDecline: () => void;
}

/** After adding Start 360: pin a Stop 360 at mission end? */
export const Record360AppendStopDialog: React.FC<Record360AppendStopDialogProps> = ({
    visible,
    onConfirm,
    onDecline,
}) => {
    const { t } = useTranslation(["missions", "common"]);

    return (
        <AnimatedModal
            visible={visible}
            onClose={onDecline}
            closeOnBackdrop={false}
            className="max-w-md rounded-r10 bg-black100 p-6"
        >
            <h2 className="mb-3 text-h4 font-semibold">{t("dialogs.record360AppendStopTitle")}</h2>
            <p className="mb-6 text-h5 text-black40">{t("dialogs.record360AppendStopBody")}</p>
            <div className="flex justify-end gap-3">
                <FunctionalButton
                    title={t("common:no")}
                    className="bg-black70 px-4 py-2"
                    onClick={onDecline}
                />
                <FunctionalButton title={t("common:yes")} className="px-4 py-2" onClick={onConfirm} />
            </div>
        </AnimatedModal>
    );
};

interface Record360StopDownloadDialogProps {
    visible: boolean;
    /** After choosing to pin stop at end, Yes/No both create the stop. */
    requireAnswer?: boolean;
    onConfirm: (download: boolean) => void;
    onClose: () => void;
}

/** Ask whether to download INSV after a Stop 360 step. */
export const Record360StopDownloadDialog: React.FC<Record360StopDownloadDialogProps> = ({
    visible,
    requireAnswer = false,
    onConfirm,
    onClose,
}) => {
    const { t } = useTranslation(["missions", "common"]);

    return (
        <AnimatedModal
            visible={visible}
            onClose={requireAnswer ? () => undefined : onClose}
            closeOnBackdrop={!requireAnswer}
            className="max-w-md rounded-r10 bg-black100 p-6"
        >
            <h2 className="mb-3 text-h4 font-semibold">{t("dialogs.record360DownloadTitle")}</h2>
            <p className="mb-6 text-h5 text-black40">{t("dialogs.record360DownloadBody")}</p>
            <div className="flex justify-end gap-3">
                <FunctionalButton
                    title={t("common:no")}
                    className="bg-black70 px-4 py-2"
                    onClick={() => onConfirm(false)}
                />
                <FunctionalButton
                    title={t("common:yes")}
                    className="px-4 py-2"
                    onClick={() => onConfirm(true)}
                />
            </div>
        </AnimatedModal>
    );
};
